<template>
    <div class="fm-content d-flex flex-column">
        <disk-list v-bind:manager="manager" style="display:none"/>
        <breadcrumb v-bind:manager="manager"/>
        <div class="fm-content-body scroll"
            ref="fm-content-body"
            @dragleave.prevent="onDragLeave($event)"
            @dragover.prevent="onDragEnter($event)"
            @drop="onDrop($event)"
            v-on:contextmenu.prevent="ShowGlobalContextMenu($event)">
          <table-view v-if="viewType === 'table'"  v-bind:manager="manager"/>
          <grid-view v-else v-bind:manager="manager"/>
        </div>
    </div>
</template>

<script>
// Components
import DiskList from './DiskList.vue';
import Breadcrumb from './Breadcrumb.vue';
import TableView from './TableView.vue';
import GridView from './GridView.vue';
import EventBus from "../eventBus";

export default {
  name: 'Manager',
  data() {
    return {
      loader: {},
    };
  },
  components: {
    DiskList,
    Breadcrumb,
    TableView,
    GridView,
  },
  props: {
    manager: { type: String, required: true },
  },
  methods: {
    /* eslint-disable no-unused-vars */
    onDragEnter(event) {
      const dropSpace = this.$refs['fm-content-body'];
      dropSpace.style.border = "3px dotted #071260";
      dropSpace.style.backgroundColor = "rgb(218, 248, 255)";
    },
    onDragLeave(event) {
       const dropSpace = this.$refs['fm-content-body'];
       dropSpace.style.border = "3px solid white";
       dropSpace.style.backgroundColor = "white";
    },
    onDrop(event) {
      event.preventDefault();
      const dropSpace = this.$refs['fm-content-body'];
      dropSpace.style.border = "3px solid white";
      dropSpace.style.backgroundColor = "white";
      const files = event.dataTransfer.files;
      this.$store.commit('setDroppedFiles', files);
      this.showModal('Upload');
    },
    ShowGlobalContextMenu(event) {
      EventBus.$emit('GlobalContextMenu', event);
    },
    /**
     * Show modal window
     * @param modalName
     */
    showModal(modalName) {
      // show selected modal
      this.$store.commit('modal/setModalState', {
        modalName,
        show: true,
      });
      this.menuVisible = false;
    },
  },
  computed: {
    /**
     * view type - grid or table
     * @returns {default.computed.viewType|(function())|string}
     */
    viewType() {
      this.$store.commit(`left/setView`, localStorage.getItem('view'));
      return this.$store.state.left.viewType;
    },
    /**
     * Spinner
     * @returns {number}
     */
    loadingSpinner() {
      if (this.$store.state.messages.loading !== 0) {
          return true
      }
      return false;
    },
  }
};
</script>

<style lang="scss">
  .fm-content {
    height: 100%;
    padding-left: 1rem;

    .fm-content-body {
        height: calc( 100vh - 160px );
        box-sizing: padding-box;
        transition: border 0.6s ease;
        border: 3px solid white;
    }    
  }
</style>
